/* tslint:disable */
/* eslint-disable */
/**
 * Influfect クライアント API
 * Influfect クライアント APIドキュメント
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccountFollowerAttributes
 */
export interface AccountFollowerAttributes {
    /**
     * 
     * @type {FollowerAttrDistributions}
     * @memberof AccountFollowerAttributes
     */
    'ageDistribution': FollowerAttrDistributions;
    /**
     * 
     * @type {FollowerAttrDistributions}
     * @memberof AccountFollowerAttributes
     */
    'genreDistribution': FollowerAttrDistributions;
    /**
     * 
     * @type {FollowerAttrDistributions}
     * @memberof AccountFollowerAttributes
     */
    'valuesDistribution': FollowerAttrDistributions;
}
/**
 * 
 * @export
 * @interface AffectOutput
 */
export interface AffectOutput {
    /**
     * 
     * @type {string}
     * @memberof AffectOutput
     */
    'affected': string;
}
/**
 * 
 * @export
 * @interface AgeDistribution
 */
export interface AgeDistribution {
    /**
     * 
     * @type {AgeDistributionType}
     * @memberof AgeDistribution
     */
    'distribution': AgeDistributionType;
    /**
     * 
     * @type {number}
     * @memberof AgeDistribution
     */
    'mans': number;
    /**
     * 
     * @type {number}
     * @memberof AgeDistribution
     */
    'womans': number;
    /**
     * 
     * @type {number}
     * @memberof AgeDistribution
     */
    'others': number;
}


/**
 * 年齢層割合種別
 * @export
 * @enum {string}
 */

export const AgeDistributionType = {
    _1317: '13-17',
    _1824: '18-24',
    _2534: '25-34',
    _3544: '35-44',
    _4554: '45-54',
    _5564: '55-64',
    _65: '65+'
} as const;

export type AgeDistributionType = typeof AgeDistributionType[keyof typeof AgeDistributionType];


/**
 * 
 * @export
 * @interface AnalysisFollowerAttributes
 */
export interface AnalysisFollowerAttributes {
    /**
     * 
     * @type {InstagramFollowerAttributes}
     * @memberof AnalysisFollowerAttributes
     */
    'instagram'?: InstagramFollowerAttributes;
    /**
     * 
     * @type {AccountFollowerAttributes}
     * @memberof AnalysisFollowerAttributes
     */
    'account': AccountFollowerAttributes;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostContentInstagram
 */
export interface AnalysisSpiritPostContentInstagram {
    /**
     * 画像の場合のみ
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'postImage'?: string | null;
    /**
     * 動画の場合のみ
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'postVideo'?: string | null;
    /**
     * カルーセルの場合のみ。複数の場合はカンマ区切り
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'postCarousel'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'carouselImages'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'thumbnail': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'postedAt': string | null;
    /**
     * メディアプロダクト種別
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'mediaProductType': AnalysisSpiritPostContentInstagramMediaProductTypeEnum | null;
    /**
     * メディア種別
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'mediaType': AnalysisSpiritPostContentInstagramMediaTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'caption': string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'followerOnPost': number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentInstagram
     */
    'url': string | null;
}

export const AnalysisSpiritPostContentInstagramMediaProductTypeEnum = {
    Ad: 'AD',
    Feed: 'FEED',
    Story: 'STORY',
    Reels: 'REELS'
} as const;

export type AnalysisSpiritPostContentInstagramMediaProductTypeEnum = typeof AnalysisSpiritPostContentInstagramMediaProductTypeEnum[keyof typeof AnalysisSpiritPostContentInstagramMediaProductTypeEnum];
export const AnalysisSpiritPostContentInstagramMediaTypeEnum = {
    CarouselAlbum: 'CAROUSEL_ALBUM',
    Image: 'IMAGE',
    Video: 'VIDEO'
} as const;

export type AnalysisSpiritPostContentInstagramMediaTypeEnum = typeof AnalysisSpiritPostContentInstagramMediaTypeEnum[keyof typeof AnalysisSpiritPostContentInstagramMediaTypeEnum];

/**
 * 
 * @export
 * @interface AnalysisSpiritPostContentTikTok
 */
export interface AnalysisSpiritPostContentTikTok {
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'postImage': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'postedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'caption': string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'followerOnPost': number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentTikTok
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostContentX
 */
export interface AnalysisSpiritPostContentX {
    /**
     * 画像の場合のみ
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'postImage'?: string | null;
    /**
     * 動画の場合のみ
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'postVideo'?: string | null;
    /**
     * 複数メディアの場合のみ。複数の場合はカンマ区切り
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'postMedias'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AnalysisSpiritPostContentX
     */
    'multiMediaImages'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'postedAt': string | null;
    /**
     * メディア種別
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'mediaType': AnalysisSpiritPostContentXMediaTypeEnum | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'caption': string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostContentX
     */
    'followerOnPost': number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentX
     */
    'url': string | null;
}

export const AnalysisSpiritPostContentXMediaTypeEnum = {
    MultipleMedia: 'multipleMedia',
    Photo: 'photo',
    Video: 'video'
} as const;

export type AnalysisSpiritPostContentXMediaTypeEnum = typeof AnalysisSpiritPostContentXMediaTypeEnum[keyof typeof AnalysisSpiritPostContentXMediaTypeEnum];

/**
 * 
 * @export
 * @interface AnalysisSpiritPostContentYoutube
 */
export interface AnalysisSpiritPostContentYoutube {
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'postImage': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'postedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'caption': string | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'followerOnPost': number | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisSpiritPostContentYoutube
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostInsightInstagram
 */
export interface AnalysisSpiritPostInsightInstagram {
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'impressionCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'uniqueAccountCount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'engagementCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'engagementRate': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'goodCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'commentCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'shareCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'saveCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'frequency': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'tapsForwardCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'tapsBackCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'exitsCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightInstagram
     */
    'viewCount': number | null;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostInsightTikTok
 */
export interface AnalysisSpiritPostInsightTikTok {
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'engagementCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'engagementRate': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'goodCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'commentCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'shareCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightTikTok
     */
    'viewCount': number | null;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostInsightX
 */
export interface AnalysisSpiritPostInsightX {
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'engagementCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'engagementRate': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'goodCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'repostCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'replyCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightX
     */
    'viewCount': number | null;
}
/**
 * 
 * @export
 * @interface AnalysisSpiritPostInsightYoutube
 */
export interface AnalysisSpiritPostInsightYoutube {
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightYoutube
     */
    'engagementCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightYoutube
     */
    'engagementRate': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightYoutube
     */
    'goodCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightYoutube
     */
    'commentCount': number | null;
    /**
     * 
     * @type {number}
     * @memberof AnalysisSpiritPostInsightYoutube
     */
    'viewCount': number | null;
}
/**
 * 
 * @export
 * @interface ApiResponseError
 */
export interface ApiResponseError {
    /**
     * 
     * @type {string}
     * @memberof ApiResponseError
     */
    'error': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiResponseError
     */
    'messages'?: Array<string>;
}
/**
 * 承認ステータス
 * @export
 * @enum {string}
 */

export const ApprovalStatus = {
    Review: 'review',
    Approved: 'approved',
    Rejected: 'rejected'
} as const;

export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus];


/**
 * 
 * @export
 * @interface Evaluation
 */
export interface Evaluation {
    /**
     * 
     * @type {number}
     * @memberof Evaluation
     */
    'evaluation': number;
    /**
     * 
     * @type {number}
     * @memberof Evaluation
     */
    'evaluationCounts': number;
    /**
     * 
     * @type {Array<EvaluationRate>}
     * @memberof Evaluation
     */
    'evaluationRates': Array<EvaluationRate>;
}
/**
 * 
 * @export
 * @interface EvaluationRate
 */
export interface EvaluationRate {
    /**
     * 
     * @type {number}
     * @memberof EvaluationRate
     */
    'rate': number;
    /**
     * 1〜5の整数値
     * @type {number}
     * @memberof EvaluationRate
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface FeedbackAdopterCommon
 */
export interface FeedbackAdopterCommon {
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'feedbackId': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'adoptedInfluencerId': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'applyingInfluencerId': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'snsAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'snsAccountNo': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'snsAccountThumbnail': string | null;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'influencerId': string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'evaluationId': string;
    /**
     * 評価値
     * @type {number}
     * @memberof FeedbackAdopterCommon
     */
    'evaluation': number;
    /**
     * 
     * @type {string}
     * @memberof FeedbackAdopterCommon
     */
    'feedbackComment': string;
}
/**
 * フィードバックステータス
 * @export
 * @enum {string}
 */

export const FeedbackStatus = {
    Ready: 'ready',
    Client: 'client',
    Admin: 'admin'
} as const;

export type FeedbackStatus = typeof FeedbackStatus[keyof typeof FeedbackStatus];


/**
 * 
 * @export
 * @interface FollowerAttrDistribution
 */
export interface FollowerAttrDistribution {
    /**
     * 
     * @type {string}
     * @memberof FollowerAttrDistribution
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof FollowerAttrDistribution
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof FollowerAttrDistribution
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface FollowerAttrDistributions
 */
export interface FollowerAttrDistributions {
    /**
     * 
     * @type {number}
     * @memberof FollowerAttrDistributions
     */
    'total': number;
    /**
     * 
     * @type {Array<FollowerAttrDistribution>}
     * @memberof FollowerAttrDistributions
     */
    'items': Array<FollowerAttrDistribution>;
}
/**
 * 端数処理種別
 * @export
 * @enum {string}
 */

export const FractionType = {
    Floor: 'floor',
    Ceiling: 'ceiling',
    Round: 'round'
} as const;

export type FractionType = typeof FractionType[keyof typeof FractionType];


/**
 * 
 * @export
 * @interface GenderDistribution
 */
export interface GenderDistribution {
    /**
     * 1:男性、2:女性、3:その他
     * @type {number}
     * @memberof GenderDistribution
     */
    'gender': number;
    /**
     * 
     * @type {number}
     * @memberof GenderDistribution
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof GenderDistribution
     */
    'rate': number;
}
/**
 * 
 * @export
 * @interface GenderDistributionWithTotal
 */
export interface GenderDistributionWithTotal {
    /**
     * 
     * @type {number}
     * @memberof GenderDistributionWithTotal
     */
    'total': number;
    /**
     * 
     * @type {Array<GenderDistribution>}
     * @memberof GenderDistributionWithTotal
     */
    'items': Array<GenderDistribution>;
}
/**
 * 
 * @export
 * @interface GetSpiritApplicantsOutput
 */
export interface GetSpiritApplicantsOutput {
    /**
     * 
     * @type {number}
     * @memberof GetSpiritApplicantsOutput
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritApplicantsOutput
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritApplicantsOutput
     */
    'perPage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritApplicantsOutput
     */
    'totalRows': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritApplicantsOutput
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<ProjectApplicantItem>}
     * @memberof GetSpiritApplicantsOutput
     */
    'rows': Array<ProjectApplicantItem>;
    /**
     * 
     * @type {ProjectApplicantCount}
     * @memberof GetSpiritApplicantsOutput
     */
    'count': ProjectApplicantCount;
}
/**
 * 
 * @export
 * @interface GetSpiritDetailOutput
 */
export interface GetSpiritDetailOutput {
    /**
     * 
     * @type {ProjectDetailHeader}
     * @memberof GetSpiritDetailOutput
     */
    'header': ProjectDetailHeader;
    /**
     * 
     * @type {string}
     * @memberof GetSpiritDetailOutput
     */
    'title': string | null;
    /**
     * 
     * @type {SnsType}
     * @memberof GetSpiritDetailOutput
     */
    'snsType': SnsType;
    /**
     * 
     * @type {string}
     * @memberof GetSpiritDetailOutput
     */
    'featuredImage': string | null;
    /**
     * 
     * @type {Array<ProjectImageRow>}
     * @memberof GetSpiritDetailOutput
     */
    'detailImages': Array<ProjectImageRow>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSpiritDetailOutput
     */
    'tags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSpiritDetailOutput
     */
    'selectionStartedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSpiritDetailOutput
     */
    'selectionEndedAt': string | null;
    /**
     * 
     * @type {SpiritSummary}
     * @memberof GetSpiritDetailOutput
     */
    'summary': SpiritSummary;
    /**
     * 
     * @type {SpiritSummaryOption}
     * @memberof GetSpiritDetailOutput
     */
    'options': SpiritSummaryOption;
    /**
     * 
     * @type {Array<SpiritTaskItem>}
     * @memberof GetSpiritDetailOutput
     */
    'tasks': Array<SpiritTaskItem>;
    /**
     * 
     * @type {ProjectSummaryDetails}
     * @memberof GetSpiritDetailOutput
     */
    'details': ProjectSummaryDetails;
    /**
     * 案件期間配列
     * @type {Array<ProjectSchedule>}
     * @memberof GetSpiritDetailOutput
     */
    'schedules': Array<ProjectSchedule>;
    /**
     * 
     * @type {ProjectKpi}
     * @memberof GetSpiritDetailOutput
     */
    'kpi': ProjectKpi;
    /**
     * 
     * @type {ProjectEstimate}
     * @memberof GetSpiritDetailOutput
     */
    'estimate': ProjectEstimate;
}


/**
 * 
 * @export
 * @interface GetSpiritList400Response
 */
export interface GetSpiritList400Response {
    /**
     * 
     * @type {string}
     * @memberof GetSpiritList400Response
     */
    'error': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSpiritList400Response
     */
    'messages'?: Array<string>;
}
/**
 * 
 * @export
 * @interface GetSpiritListOutput
 */
export interface GetSpiritListOutput {
    /**
     * 
     * @type {number}
     * @memberof GetSpiritListOutput
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritListOutput
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritListOutput
     */
    'perPage': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritListOutput
     */
    'totalRows': number;
    /**
     * 
     * @type {number}
     * @memberof GetSpiritListOutput
     */
    'totalPages': number;
    /**
     * 
     * @type {Array<Spirit>}
     * @memberof GetSpiritListOutput
     */
    'rows': Array<Spirit>;
    /**
     * 
     * @type {ProjectTypeListCounts}
     * @memberof GetSpiritListOutput
     */
    'counts': ProjectTypeListCounts;
}
/**
 * 
 * @export
 * @interface InstagramFollowerAttributes
 */
export interface InstagramFollowerAttributes {
    /**
     * 
     * @type {Array<AgeDistribution>}
     * @memberof InstagramFollowerAttributes
     */
    'ageDistribution': Array<AgeDistribution>;
    /**
     * 
     * @type {Array<PrefDistribution>}
     * @memberof InstagramFollowerAttributes
     */
    'prefDistribution': Array<PrefDistribution>;
    /**
     * 
     * @type {GenderDistributionWithTotal}
     * @memberof InstagramFollowerAttributes
     */
    'genderDistribution': GenderDistributionWithTotal;
}
/**
 * 
 * @export
 * @interface PaginationOutput
 */
export interface PaginationOutput {
    /**
     * 
     * @type {number}
     * @memberof PaginationOutput
     */
    'from': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationOutput
     */
    'to': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationOutput
     */
    'perPage': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationOutput
     */
    'totalRows': number;
    /**
     * 
     * @type {number}
     * @memberof PaginationOutput
     */
    'totalPages': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PostingType = {
    Reel: 'reel',
    Feed: 'feed',
    Stories: 'stories',
    XImagePost: 'x_image_post',
    XPost: 'x_post',
    YoutubeShort: 'youtube_short',
    Youtube: 'youtube',
    TikTok: 'tik_tok',
    OtherVideo: 'other_video',
    Other: 'other'
} as const;

export type PostingType = typeof PostingType[keyof typeof PostingType];


/**
 * 
 * @export
 * @interface PrefDistribution
 */
export interface PrefDistribution {
    /**
     * 
     * @type {string}
     * @memberof PrefDistribution
     */
    'prefCode': string;
    /**
     * 
     * @type {number}
     * @memberof PrefDistribution
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface ProjectApplicantCount
 */
export interface ProjectApplicantCount {
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantCount
     */
    'applicant': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantCount
     */
    'approved': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantCount
     */
    'reserved': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantCount
     */
    'canBeReserver': number;
}
/**
 * 
 * @export
 * @interface ProjectApplicantItem
 */
export interface ProjectApplicantItem {
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'applicantIndex': number;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'influencerId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'snsAccountNo': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'snsAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'thumbnail': string | null;
    /**
     * 採用されてない場合はnull
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'adoptedInfluencerId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'evaluation': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'evaluationCounts': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectApplicantItem
     */
    'follow': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'enthusiasm': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectApplicantItem
     */
    'isAlternate': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'operatorComment': string | null;
    /**
     * 採用:1、補欠:2、不採用:3
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'selectionStatus': number;
    /**
     * 最終確認 unconfirmed: 未確認 confirming: 確認中 confirmed_ok: 確認OK confirmed_ng: 確認NG
     * @type {string}
     * @memberof ProjectApplicantItem
     */
    'isFinalConfirmation'?: ProjectApplicantItemIsFinalConfirmationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProjectApplicantItem
     */
    'isGoodQuality'?: boolean | null;
    /**
     * フォロワー数/チャンネル登録者数
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'followers'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'following'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'impressions'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'reach'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'reachRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'preservations'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'engagements'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'engagementRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'frequency'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'reply'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'repost'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'goodAvg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'shareAvg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'views'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'viewRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'commentsAvg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'highEvaluationAvg'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectApplicantItem
     */
    'mediaCount'?: number | null;
    /**
     * 
     * @type {SnsType}
     * @memberof ProjectApplicantItem
     */
    'snsType': SnsType;
}

export const ProjectApplicantItemIsFinalConfirmationEnum = {
    Unconfirmed: 'unconfirmed',
    Confirming: 'confirming',
    ConfirmedOk: 'confirmed_ok',
    ConfirmedNg: 'confirmed_ng'
} as const;

export type ProjectApplicantItemIsFinalConfirmationEnum = typeof ProjectApplicantItemIsFinalConfirmationEnum[keyof typeof ProjectApplicantItemIsFinalConfirmationEnum];

/**
 * 
 * @export
 * @interface ProjectCalculateReward
 */
export interface ProjectCalculateReward {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectCalculateReward
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProjectCalculateReward
     */
    'standard': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectCalculateReward
     */
    'minimum': number;
}
/**
 * 
 * @export
 * @interface ProjectDetailHeader
 */
export interface ProjectDetailHeader {
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'projectGroupName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'projectName': string;
    /**
     * 
     * @type {ProjectType}
     * @memberof ProjectDetailHeader
     */
    'projectType': ProjectType;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof ProjectDetailHeader
     */
    'projectStatus': ProjectStatus;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'teamId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'teamName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'teamManagerName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'scheduleStartedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'scheduleEndedAt': string | null;
    /**
     * 
     * @type {FeedbackStatus}
     * @memberof ProjectDetailHeader
     */
    'feedbackStatus': FeedbackStatus | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'managerId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectDetailHeader
     */
    'managerName': string | null;
}


/**
 * 
 * @export
 * @interface ProjectEstimate
 */
export interface ProjectEstimate {
    /**
     * 
     * @type {boolean}
     * @memberof ProjectEstimate
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {ProjectEstimateItemGroups}
     * @memberof ProjectEstimate
     */
    'items': ProjectEstimateItemGroups;
    /**
     * オプション選択肢配列
     * @type {Array<ProjectOptionChoice>}
     * @memberof ProjectEstimate
     */
    'optionChoices': Array<ProjectOptionChoice>;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimate
     */
    'subtotal': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimate
     */
    'tax': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimate
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimate
     */
    'taxRate': number;
    /**
     * 
     * @type {FractionType}
     * @memberof ProjectEstimate
     */
    'fractionType': FractionType;
    /**
     * 
     * @type {ProjectCalculateReward}
     * @memberof ProjectEstimate
     */
    'calculateReward': ProjectCalculateReward;
}


/**
 * 
 * @export
 * @interface ProjectEstimateItem
 */
export interface ProjectEstimateItem {
    /**
     * 
     * @type {string}
     * @memberof ProjectEstimateItem
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimateItem
     */
    'counts': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimateItem
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectEstimateItem
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface ProjectEstimateItemGroups
 */
export interface ProjectEstimateItemGroups {
    /**
     * 案件見積明細配列
     * @type {Array<ProjectEstimateItem>}
     * @memberof ProjectEstimateItemGroups
     */
    'fixedItems': Array<ProjectEstimateItem>;
    /**
     * 案件見積明細配列
     * @type {Array<ProjectEstimateItem>}
     * @memberof ProjectEstimateItemGroups
     */
    'optionFixedItems': Array<ProjectEstimateItem>;
    /**
     * 案件見積明細配列
     * @type {Array<ProjectEstimateItem>}
     * @memberof ProjectEstimateItemGroups
     */
    'optionFreeItems': Array<ProjectEstimateItem>;
}
/**
 * 
 * @export
 * @interface ProjectImageRow
 */
export interface ProjectImageRow {
    /**
     * 
     * @type {string}
     * @memberof ProjectImageRow
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectImageRow
     */
    'objectKey': string;
}
/**
 * 
 * @export
 * @interface ProjectKpi
 */
export interface ProjectKpi {
    /**
     * KPI項目配列
     * @type {Array<ProjectKpiItem>}
     * @memberof ProjectKpi
     */
    'items': Array<ProjectKpiItem>;
}
/**
 * 
 * @export
 * @interface ProjectKpiItem
 */
export interface ProjectKpiItem {
    /**
     * 
     * @type {string}
     * @memberof ProjectKpiItem
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectKpiItem
     */
    'comment': string;
    /**
     * POST時isFixedは指定しなくてもtrueになります。
     * @type {boolean}
     * @memberof ProjectKpiItem
     */
    'isFixed': boolean;
}
/**
 * 
 * @export
 * @interface ProjectOptionChoice
 */
export interface ProjectOptionChoice {
    /**
     * 
     * @type {string}
     * @memberof ProjectOptionChoice
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ProjectOptionChoice
     */
    'price': number;
}
/**
 * 最終確定日など期間ではないものはfromにnullを設定する
 * @export
 * @interface ProjectSchedule
 */
export interface ProjectSchedule {
    /**
     * 
     * @type {string}
     * @memberof ProjectSchedule
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectSchedule
     */
    'from': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectSchedule
     */
    'to': string | null;
}
/**
 * 案件スケジュールステータス
 * @export
 * @enum {string}
 */

export const ProjectScheduleStatus = {
    Before: 'before',
    During: 'during',
    Ending: 'ending'
} as const;

export type ProjectScheduleStatus = typeof ProjectScheduleStatus[keyof typeof ProjectScheduleStatus];


/**
 * <table> <tr><td>募集内容作成（下書き）</td><td>draft</td></tr> <tr><td>募集内容作成（申請中）</td><td>review</td></tr> <tr><td>募集〜選考</td><td>approved</td></tr> <tr><td>最終確認</td><td>final_confirmation</td></tr> <tr><td>実施中</td><td>implementation</td></tr> <tr><td>完了</td><td>completion</td></tr> <tr><td>募集完了(PRST)</td><td>accept_completion</td></tr> <tr><td>配信詳細作成（下書き）</td><td>post_draft</td></tr> <tr><td>配信詳細作成（申請中）</td><td>post_review</td></tr> <tr><td>配信待ち(EMERALD POST)</td><td>wait_post</td></tr> <tr><td>配信中(EMERALD POST)</td><td>posting</td></tr> <tr><td>配信完了(EMERALD POST)</td><td>post_completion</td></tr> </table>
 * @export
 * @enum {string}
 */

export const ProjectStatus = {
    Draft: 'draft',
    Review: 'review',
    Approved: 'approved',
    FinalConfirmation: 'final_confirmation',
    WaitPost: 'wait_post',
    Implementation: 'implementation',
    PostDraft: 'post_draft',
    PostReview: 'post_review',
    Posting: 'posting',
    Completion: 'completion',
    PostCompletion: 'post_completion',
    AcceptCompletion: 'accept_completion'
} as const;

export type ProjectStatus = typeof ProjectStatus[keyof typeof ProjectStatus];


/**
 * 
 * @export
 * @interface ProjectSummaryApplicationCondition
 */
export interface ProjectSummaryApplicationCondition {
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'minFollowers': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'gender': ProjectSummaryApplicationConditionGenderEnum | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'minAge': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'maxAge': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectSummaryApplicationCondition
     */
    'prefectures': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'minAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'maxAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryApplicationCondition
     */
    'job': number | null;
}

export const ProjectSummaryApplicationConditionGenderEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type ProjectSummaryApplicationConditionGenderEnum = typeof ProjectSummaryApplicationConditionGenderEnum[keyof typeof ProjectSummaryApplicationConditionGenderEnum];

/**
 * 
 * @export
 * @interface ProjectSummaryBase
 */
export interface ProjectSummaryBase {
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryBase
     */
    'adoptionPlan': number;
    /**
     * 0:適正相場 1:カスタム設定 （Spirit以外では無視されます）
     * @type {number}
     * @memberof ProjectSummaryBase
     */
    'rewardsType': number | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectSummaryBase
     */
    'rewards': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectSummaryBase
     */
    'genres': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectSummaryBase
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface ProjectSummaryDetails
 */
export interface ProjectSummaryDetails {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectSummaryDetails
     */
    'notice': Array<string> | null;
    /**
     * true:非公開 false:公開
     * @type {boolean}
     * @memberof ProjectSummaryDetails
     */
    'isSecret': boolean;
    /**
     * 
     * @type {string}
     * @memberof ProjectSummaryDetails
     */
    'companyName': string;
}
/**
 * 案件タイプ
 * @export
 * @enum {string}
 */

export const ProjectType = {
    Spirit: 'spirit',
    EmeraldPost: 'emerald_post',
    Prst: 'prst',
    JaneJohn: 'jane_john',
    Other: 'other'
} as const;

export type ProjectType = typeof ProjectType[keyof typeof ProjectType];


/**
 * 
 * @export
 * @interface ProjectTypeItem
 */
export interface ProjectTypeItem {
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeItem
     */
    'no': number;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'projectGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'projectGroupName': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof ProjectTypeItem
     */
    'endDate': string | null;
}
/**
 * 
 * @export
 * @interface ProjectTypeListCounts
 */
export interface ProjectTypeListCounts {
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'all': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'draft': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'review': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'approved': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'finalConfirmation': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'implementation': number;
    /**
     * 
     * @type {number}
     * @memberof ProjectTypeListCounts
     */
    'completion': number;
}
/**
 * 
 * @export
 * @interface PutSpiritNoticeInput
 */
export interface PutSpiritNoticeInput {
    /**
     * 
     * @type {boolean}
     * @memberof PutSpiritNoticeInput
     */
    'isPublic': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutSpiritNoticeInput
     */
    'notice': Array<string>;
}
/**
 * 
 * @export
 * @interface PutSpiritSummaryInput
 */
export interface PutSpiritSummaryInput {
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'adoptionPlan': number;
    /**
     * 0:適正相場 1:カスタム設定 （Spirit以外では無視されます）
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'rewardsType': number | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'rewards': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutSpiritSummaryInput
     */
    'genres': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof PutSpiritSummaryInput
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'minFollowers': number | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'gender': PutSpiritSummaryInputGenderEnum | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'minAge': number | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'maxAge': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PutSpiritSummaryInput
     */
    'prefectures': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'minAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'maxAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof PutSpiritSummaryInput
     */
    'job': number | null;
}

export const PutSpiritSummaryInputGenderEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type PutSpiritSummaryInputGenderEnum = typeof PutSpiritSummaryInputGenderEnum[keyof typeof PutSpiritSummaryInputGenderEnum];

/**
 * SNSタイプ
 * @export
 * @enum {string}
 */

export const SnsType = {
    Instagram: 'instagram',
    X: 'x',
    TikTok: 'tik_tok',
    Youtube: 'youtube',
    Other: 'other'
} as const;

export type SnsType = typeof SnsType[keyof typeof SnsType];


/**
 * 
 * @export
 * @interface Spirit
 */
export interface Spirit {
    /**
     * 
     * @type {number}
     * @memberof Spirit
     */
    'no': number;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'projectId': string;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'projectGroupId': string | null;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'projectGroupName': string | null;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'startDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof Spirit
     */
    'endDate': string | null;
    /**
     * spirit 固定
     * @type {string}
     * @memberof Spirit
     */
    'projectType': SpiritProjectTypeEnum;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof Spirit
     */
    'status': ProjectStatus;
    /**
     * 
     * @type {SnsType}
     * @memberof Spirit
     */
    'sns': SnsType;
}

export const SpiritProjectTypeEnum = {
    Spirit: 'spirit'
} as const;

export type SpiritProjectTypeEnum = typeof SpiritProjectTypeEnum[keyof typeof SpiritProjectTypeEnum];

/**
 * 
 * @export
 * @interface SpiritHearingOption
 */
export interface SpiritHearingOption {
    /**
     * 1: サンプリング, 2: バイイング(店舗), 3: バイイング(EC), 4: イベント, 5: WEBサービス・アプリ利用, 10: Instagram(フィート投稿), 11: Instagram(ストーリーズ投稿), 12: Instagram(リール投稿), 20: X(ポスト投稿), 21: X(引用ポスト投稿), 30: TikTok, 40: Youtube
     * @type {number}
     * @memberof SpiritHearingOption
     */
    'taskType': number;
    /**
     * 
     * @type {Array<SpiritSelectedOptionItems>}
     * @memberof SpiritHearingOption
     */
    'selectedOptionItems': Array<SpiritSelectedOptionItems>;
}
/**
 * 
 * @export
 * @interface SpiritListRows
 */
export interface SpiritListRows {
    /**
     * 
     * @type {Array<Spirit>}
     * @memberof SpiritListRows
     */
    'rows': Array<Spirit>;
}
/**
 * 
 * @export
 * @interface SpiritSchedule
 */
export interface SpiritSchedule {
    /**
     * 
     * @type {string}
     * @memberof SpiritSchedule
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof SpiritSchedule
     */
    'from': string;
    /**
     * 
     * @type {string}
     * @memberof SpiritSchedule
     */
    'to': string;
    /**
     * 
     * @type {ProjectScheduleStatus}
     * @memberof SpiritSchedule
     */
    'status': ProjectScheduleStatus;
}


/**
 * 
 * @export
 * @interface SpiritSelectedOptionItems
 */
export interface SpiritSelectedOptionItems {
    /**
     * 
     * @type {string}
     * @memberof SpiritSelectedOptionItems
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpiritSelectedOptionItems
     */
    'optionItems': Array<string>;
}
/**
 * 
 * @export
 * @interface SpiritSummary
 */
export interface SpiritSummary {
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'adoptionPlan': number;
    /**
     * 0:適正相場 1:カスタム設定 （Spirit以外では無視されます）
     * @type {number}
     * @memberof SpiritSummary
     */
    'rewardsType': number | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'rewards': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpiritSummary
     */
    'genres': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SpiritSummary
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'minFollowers': number | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'gender': SpiritSummaryGenderEnum | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'minAge': number | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'maxAge': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof SpiritSummary
     */
    'prefectures': Array<string> | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'minAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'maxAnnualIncome': number | null;
    /**
     * 
     * @type {number}
     * @memberof SpiritSummary
     */
    'job': number | null;
}

export const SpiritSummaryGenderEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type SpiritSummaryGenderEnum = typeof SpiritSummaryGenderEnum[keyof typeof SpiritSummaryGenderEnum];

/**
 * 
 * @export
 * @interface SpiritSummaryOption
 */
export interface SpiritSummaryOption {
    /**
     * 0:なし 1:¥30,000 2:¥50,000
     * @type {number}
     * @memberof SpiritSummaryOption
     */
    'goodQuality': number;
    /**
     * 0:なし 1:あり
     * @type {number}
     * @memberof SpiritSummaryOption
     */
    'secondaryUse': number;
    /**
     * 0:なし 1:あり
     * @type {number}
     * @memberof SpiritSummaryOption
     */
    'adoptionOutsourced': number;
}
/**
 * 
 * @export
 * @interface SpiritTaskItem
 */
export interface SpiritTaskItem {
    /**
     * 新規作成時はnullを指定
     * @type {string}
     * @memberof SpiritTaskItem
     */
    'taskId': string | null;
    /**
     * 1: サンプリング, 2: バイイング(店舗), 3: バイイング(EC), 4: イベント, 5: WEBサービス・アプリ利用, 10: Instagram(フィート投稿), 11: Instagram(ストーリーズ投稿), 12: Instagram(リール投稿), 20: X(ポスト投稿), 21: X(引用ポスト投稿), 30: TikTok, 40: Youtube
     * @type {number}
     * @memberof SpiritTaskItem
     */
    'taskType': number;
    /**
     * 
     * @type {SpiritTaskItemDetail}
     * @memberof SpiritTaskItem
     */
    'detail': SpiritTaskItemDetail;
}
/**
 * @type SpiritTaskItemDetail
 * @export
 */
export type SpiritTaskItemDetail = TaskBuying | TaskEvent | TaskInstagramFeed | TaskInstagramReel | TaskInstagramStories | TaskSampling | TaskTikTokFeed | TaskWebApp | TaskXPost | TaskYoutubeFeed;

/**
 * 
 * @export
 * @interface TaskBuying
 */
export interface TaskBuying {
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'shopInformation'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'ecUrl'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskBuying
     */
    'isEvidence': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskBuying
     */
    'evidenceNotice': string | null;
    /**
     * 商品説明
     * @type {string}
     * @memberof TaskBuying
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof TaskBuying
     */
    'price': number;
    /**
     * 
     * @type {Array<TaskOptionItem>}
     * @memberof TaskBuying
     */
    'options': Array<TaskOptionItem>;
}
/**
 * 
 * @export
 * @interface TaskEvent
 */
export interface TaskEvent {
    /**
     * 
     * @type {string}
     * @memberof TaskEvent
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskEvent
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskEvent
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskEvent
     */
    'description': string;
    /**
     * 
     * @type {Array<TaskOptionItem>}
     * @memberof TaskEvent
     */
    'options': Array<TaskOptionItem>;
}
/**
 * 
 * @export
 * @interface TaskInstagramFeed
 */
export interface TaskInstagramFeed {
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramFeed
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramFeed
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramFeed
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramFeed
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramFeed
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramFeed
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramFeed
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramFeed
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramFeed
     */
    'isSecretAccountTag': boolean;
    /**
     * 画像（imageNum）と動画（movieNum）の合計枚数が10以上の場合はエラーとなります。
     * @type {number}
     * @memberof TaskInstagramFeed
     */
    'imageNum': number;
    /**
     * 画像（imageNum）と動画（movieNum）の合計枚数が10以上の場合はエラーとなります。
     * @type {number}
     * @memberof TaskInstagramFeed
     */
    'movieNum': number;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramFeed
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramFeed
     */
    'isSecretLocation': boolean;
}
/**
 * 
 * @export
 * @interface TaskInstagramReel
 */
export interface TaskInstagramReel {
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramReel
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramReel
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramReel
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramReel
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramReel
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramReel
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramReel
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramReel
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramReel
     */
    'isSecretAccountTag': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramReel
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramReel
     */
    'isSecretLocation': boolean;
}
/**
 * 
 * @export
 * @interface TaskInstagramStories
 */
export interface TaskInstagramStories {
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramStories
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramStories
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramStories
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskInstagramStories
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramStories
     */
    'isSecretAccountTag': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramStories
     */
    'highlight': boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskInstagramStories
     */
    'publicationWeek': number;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramStories
     */
    'isSecretLocation': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskInstagramStories
     */
    'url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskInstagramStories
     */
    'isSecretUrl': boolean;
}
/**
 * 
 * @export
 * @interface TaskOptionItem
 */
export interface TaskOptionItem {
    /**
     * 
     * @type {string}
     * @memberof TaskOptionItem
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskOptionItem
     */
    'options': Array<string>;
    /**
     * true:可 false:不可（イベント、WEBサービス・アプリ利用では無視されます）
     * @type {boolean}
     * @memberof TaskOptionItem
     */
    'selectable'?: boolean;
    /**
     * サンプリング、バイイングで選択不可にした場合は無視されます。最大5
     * @type {number}
     * @memberof TaskOptionItem
     */
    'amount'?: number;
}
/**
 * 
 * @export
 * @interface TaskPostComponent
 */
export interface TaskPostComponent {
    /**
     * 
     * @type {string}
     * @memberof TaskPostComponent
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskPostComponent
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskPostComponent
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskPostComponent
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskPostComponent
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskPostComponent
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskPostComponent
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskPostComponent
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskPostComponent
     */
    'isSecretAccountTag': boolean;
}
/**
 * 
 * @export
 * @interface TaskSampling
 */
export interface TaskSampling {
    /**
     * 
     * @type {string}
     * @memberof TaskSampling
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskSampling
     */
    'arrivalDate': string;
    /**
     * 
     * @type {string}
     * @memberof TaskSampling
     */
    'summaryText': string;
    /**
     * 
     * @type {Array<TaskOptionItem>}
     * @memberof TaskSampling
     */
    'options': Array<TaskOptionItem>;
}
/**
 * 
 * @export
 * @interface TaskTikTokFeed
 */
export interface TaskTikTokFeed {
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskTikTokFeed
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskTikTokFeed
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTikTokFeed
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskTikTokFeed
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTikTokFeed
     */
    'isSecretAccountTag': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTikTokFeed
     */
    'isSecretLocation': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskTikTokFeed
     */
    'url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTikTokFeed
     */
    'isSecretUrl': boolean;
}
/**
 * 
 * @export
 * @interface TaskWebApp
 */
export interface TaskWebApp {
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'downloadUrl': string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskWebApp
     */
    'isEvidence': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'evidenceNotice': string | null;
    /**
     * 
     * @type {string}
     * @memberof TaskWebApp
     */
    'description': string;
    /**
     * 
     * @type {Array<TaskOptionItem>}
     * @memberof TaskWebApp
     */
    'options': Array<TaskOptionItem>;
}
/**
 * 
 * @export
 * @interface TaskXPost
 */
export interface TaskXPost {
    /**
     * 
     * @type {string}
     * @memberof TaskXPost
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskXPost
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskXPost
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskXPost
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskXPost
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskXPost
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskXPost
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskXPost
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskXPost
     */
    'isSecretAccountTag': boolean;
    /**
     * 1:テキストのみ 2:画像・動画 <br> 「5:ツイート」時のみ有効、引用ツイートの場合は無視されます。
     * @type {number}
     * @memberof TaskXPost
     */
    'postMethod': number;
    /**
     * postMethodが\'2\'の場合のみ有効<br>画像（imageNum）と動画（movieNum）の合計枚数が4以上の場合はエラーとなります。
     * @type {number}
     * @memberof TaskXPost
     */
    'imageNum': number;
    /**
     * postMethodが\'2\'の場合のみ有効<br>画像（imageNum）と動画（movieNum）の合計枚数が4以上の場合はエラーとなります。
     * @type {number}
     * @memberof TaskXPost
     */
    'movieNum': number;
    /**
     * 
     * @type {string}
     * @memberof TaskXPost
     */
    'url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskXPost
     */
    'isSecretUrl': boolean;
}
/**
 * 
 * @export
 * @interface TaskYoutubeFeed
 */
export interface TaskYoutubeFeed {
    /**
     * 
     * @type {string}
     * @memberof TaskYoutubeFeed
     */
    'startedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskYoutubeFeed
     */
    'endedAt': string;
    /**
     * 
     * @type {string}
     * @memberof TaskYoutubeFeed
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof TaskYoutubeFeed
     */
    'postingAd': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskYoutubeFeed
     */
    'requiredHashTags': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskYoutubeFeed
     */
    'OptionalHashTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskYoutubeFeed
     */
    'isSecretHashTag': boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskYoutubeFeed
     */
    'accountTags': Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskYoutubeFeed
     */
    'isSecretAccountTag': boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskYoutubeFeed
     */
    'movieType': number;
    /**
     * 
     * @type {string}
     * @memberof TaskYoutubeFeed
     */
    'url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskYoutubeFeed
     */
    'isSecretUrl': boolean;
}
/**
 * 
 * @export
 * @interface UploadedImageOutput
 */
export interface UploadedImageOutput {
    /**
     * 
     * @type {string}
     * @memberof UploadedImageOutput
     */
    'uploadedFilePath'?: string;
}

/**
 * SPIRITApi - axios parameter creator
 * @export
 */
export const SPIRITApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * SPIRIT案件応募者のヒアリング情報を取得する
         * @summary SPIRIT案件応募者ヒアリング取得API
         * @param {string} projectId 案件ID
         * @param {string} snsAccountId インフルエンサーSNSアカウントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritApplicantHearing: async (projectId: string, snsAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSpiritApplicantHearing', 'projectId', projectId)
            // verify required parameter 'snsAccountId' is not null or undefined
            assertParamExists('getSpiritApplicantHearing', 'snsAccountId', snsAccountId)
            const localVarPath = `/projects/spirit/{projectId}/applicant/hearing/{snsAccountId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"snsAccountId"}}`, encodeURIComponent(String(snsAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件 応募者/採用者一覧を返却します。 <br> 案件のステータス状況に応じて応募者and採用者か、採用者のみ返却するかが変わります。
         * @summary SPIRIT案件 応募者/採用者一覧取得API
         * @param {string} projectId 案件ID
         * @param {GetSpiritApplicantsRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritApplicantsOrderEnum} [order] 
         * @param {GetSpiritApplicantsOrderByEnum} [orderBy] デフォルトは応募順 &lt;ul&gt; &lt;li&gt;follow:気になる&lt;/li&gt; &lt;li&gt;idx:応募順&lt;/li&gt; &lt;li&gt;id:SNS ID&lt;/li&gt; &lt;li&gt;eval:評価&lt;/li&gt; &lt;li&gt;enthusiasm:応募者の意気込み&lt;/li&gt; &lt;li&gt;opeComment:弊社担当からのコメント&lt;/li&gt; &lt;li&gt;selection:選定&lt;/li&gt; &lt;li&gt;isReserved:補欠採用&lt;/li&gt; &lt;li&gt;finalConfirm:最終可否&lt;/li&gt; &lt;li&gt;followers:フォロワー数/チャンネル登録者数&lt;/li&gt; &lt;li&gt;following:フォロー数&lt;/li&gt; &lt;li&gt;impressions:インプレッション数&lt;/li&gt; &lt;li&gt;egRate:エンゲージメント率&lt;/li&gt; &lt;li&gt;engagements:エンゲージメント数&lt;/li&gt; &lt;li&gt;good:いいね数&lt;/li&gt; &lt;li&gt;comments:コメント数&lt;/li&gt; &lt;li&gt;share:共有数&lt;/li&gt; &lt;li&gt;preserves:保存数&lt;/li&gt; &lt;li&gt;reach:ユニークアカウント数&lt;/li&gt; &lt;li&gt;reachRate:ユニークアカウント率&lt;/li&gt; &lt;li&gt;frequency:フリークエンシー&lt;/li&gt; &lt;li&gt;mediaCount:投稿数/ポスト数/動画数&lt;/li&gt; &lt;li&gt;reply:返信数&lt;/li&gt; &lt;li&gt;repost:リポスト数&lt;/li&gt; &lt;li&gt;views:再生数/視聴数&lt;/li&gt; &lt;li&gt;viewRate:再生回数率/視聴回数率&lt;/li&gt; &lt;li&gt;like:高評価数&lt;/li&gt; &lt;/ul&gt;
         * @param {GetSpiritApplicantsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritApplicants: async (projectId: string, rows?: GetSpiritApplicantsRowsEnum, page?: number, order?: GetSpiritApplicantsOrderEnum, orderBy?: GetSpiritApplicantsOrderByEnum, status?: GetSpiritApplicantsStatusEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSpiritApplicants', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/applicants`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件詳細情報を返却する
         * @summary SPIRIT案件詳細情報取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritDetail: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSpiritDetail', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件種別の一覧を返却する
         * @summary SPIRIT案件一覧取得API
         * @param {GetSpiritListStatusEnum} [status] &lt;table&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;下書き&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件新規作成フローを経て案件内容が簡易提案された状態で保存した状態のこと（LIDDELL側に案件を依頼していない状態）&lt;/font&gt;&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;ここから「案件を開始」を選択すると、ステータスが「募集内容作成」に変更される&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;募集内容作成&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサー側に提示する募集内容の詳細を作成するフェーズ&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面、LDL管理画面から、募集内容の編集ができる&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にはLIDDELL側が作成する想定。（自力で募集内容の詳細を作成できるクライアントは少ないため）&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集内容の必須入力項目が全て記載されると、クライアントが確認→申請をする。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;その申請をLIDDELL側が管理画面で受け取り、スケジュールの日付設定をして承認することで「募集〜選定」フェーズへと移行する&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;無理のない案件スケジューリングを推奨するため、スケジュール設定権はLIDDELL側で持つ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt; &lt;font size&#x3D;\&quot;2\&quot;&gt;募集〜選定&lt;/font&gt; &lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集前の期間+募集期間+選定期間&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集が公開され、応募を受け付ける&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;応募者が応募者タブ内に表示されて、クライアント側で選定できるように&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサーを選定して、「採用者を確定する」ボタンを押すことで「最終確認」ステータスへ移行するイメージ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;最終確認&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LIDDELL側でインフルエンサーとやりとりをして、採用・補欠インフルエンサーに対し案件の遂行が可能かを最終確認する期間のこと&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LDL管理画面側で、最終確認完了のトリガーを設置する必要がある&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にこのフェーズ以降、クライアント側のタスクは発生しない&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;実施&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件を実施する期間。主にLIDDELL側とインフルエンサー側でやりとりをしながら、案件を遂行していく。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面側では、その進捗が反映される。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;スケジュールタブで、フェーズごとの実施ステータスが見れる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;完了&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;全ての稼働が完了（全てのインフルエンサーが案件へのフィードバックが完了）したら、案件完了ステータスとなる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;/table&gt;
         * @param {GetSpiritListListTypeEnum} [listType] 一覧種別
         * @param {GetSpiritListRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritListOrderEnum} [order] 
         * @param {string} [orderBy] ソート項目を指定しない場合、API仕様に応じてデフォルトのソート項目でソートされます。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritList: async (status?: GetSpiritListStatusEnum, listType?: GetSpiritListListTypeEnum, rows?: GetSpiritListRowsEnum, page?: number, order?: GetSpiritListOrderEnum, orderBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/projects/spirit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (listType !== undefined) {
                localVarQueryParameter['listType'] = listType;
            }

            if (rows !== undefined) {
                localVarQueryParameter['rows'] = rows;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件のスケジュールタブで表示するスケジュール情報を取得し返却する
         * @summary SPIRIT案件スケジュール取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritSchedule: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getSpiritSchedule', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/schedules`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 詳細画像の設定を行うAPI<br> アップロード自体はamplifyで実装し、バックエンドにはS3オブジェクトのキー名のみ伝えます。<br> APIでDBに保存されているキー名にマッチしないキー名がリクエストされた場合、DBに登録されていたオブジェクトは削除し、<br> 新しいキー名を案件画像として登録します。<br> リクエストボディに含まれているキー名のみDBに登録されるため、配列から除外したキー名についてはDB、S3からも削除されます。
         * @summary 詳細画像設定API
         * @param {string} projectId 案件ID
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [deleteIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritMedia: async (projectId: string, uploads?: Array<File>, deleteIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritMedia', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/media`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (uploads) {
                uploads.forEach((element) => {
                    localVarFormParams.append('uploads', element as any);
                })
            }

                if (deleteIds) {
                localVarFormParams.append('deleteIds', deleteIds.join(COLLECTION_FORMATS.csv));
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件の注意事項/公開設定を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件注意事項/公開設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritNoticeInput} [putSpiritNoticeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritNotice: async (projectId: string, putSpiritNoticeInput?: PutSpiritNoticeInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritNotice', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/notice`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSpiritNoticeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件のオプションを設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件オプション設定API
         * @param {string} projectId 案件ID
         * @param {SpiritSummaryOption} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritOptions: async (projectId: string, body?: SpiritSummaryOption, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritOptions', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/options`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件の案件概要を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件概要設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritSummaryInput} [putSpiritSummaryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritSummary: async (projectId: string, putSpiritSummaryInput?: PutSpiritSummaryInput, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritSummary', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/summary`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putSpiritSummaryInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * SPIRIT案件の稼働設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件稼働設定API
         * @param {string} projectId 案件ID
         * @param {Array<SpiritTaskItem>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritTasks: async (projectId: string, body?: Array<SpiritTaskItem>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritTasks', 'projectId', projectId)
            const localVarPath = `/projects/spirit/{projectId}/tasks`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 案件タイトルやアイキャッチ画像などタイトル部分で表示する項目設定を行うAPI<br>保存された内容をレスポンスします。
         * @summary 案件募集タイトル作成/編集API
         * @param {string} projectId 案件ID
         * @param {string} title 
         * @param {Array<string>} tags 
         * @param {File} [featuredImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritTitle: async (projectId: string, title: string, tags: Array<string>, featuredImage?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('putSpiritTitle', 'projectId', projectId)
            // verify required parameter 'title' is not null or undefined
            assertParamExists('putSpiritTitle', 'title', title)
            // verify required parameter 'tags' is not null or undefined
            assertParamExists('putSpiritTitle', 'tags', tags)
            const localVarPath = `/projects/spirit/{projectId}/title`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (title !== undefined) { 
                localVarFormParams.append('title', title as any);
            }
                if (tags) {
                tags.forEach((element) => {
                    localVarFormParams.append('tags', element as any);
                })
            }

    
            if (featuredImage !== undefined) { 
                localVarFormParams.append('featuredImage', featuredImage as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SPIRITApi - functional programming interface
 * @export
 */
export const SPIRITApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SPIRITApiAxiosParamCreator(configuration)
    return {
        /**
         * SPIRIT案件応募者のヒアリング情報を取得する
         * @summary SPIRIT案件応募者ヒアリング取得API
         * @param {string} projectId 案件ID
         * @param {string} snsAccountId インフルエンサーSNSアカウントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpiritApplicantHearing(projectId: string, snsAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpiritHearingOption>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpiritApplicantHearing(projectId, snsAccountId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.getSpiritApplicantHearing']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件 応募者/採用者一覧を返却します。 <br> 案件のステータス状況に応じて応募者and採用者か、採用者のみ返却するかが変わります。
         * @summary SPIRIT案件 応募者/採用者一覧取得API
         * @param {string} projectId 案件ID
         * @param {GetSpiritApplicantsRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritApplicantsOrderEnum} [order] 
         * @param {GetSpiritApplicantsOrderByEnum} [orderBy] デフォルトは応募順 &lt;ul&gt; &lt;li&gt;follow:気になる&lt;/li&gt; &lt;li&gt;idx:応募順&lt;/li&gt; &lt;li&gt;id:SNS ID&lt;/li&gt; &lt;li&gt;eval:評価&lt;/li&gt; &lt;li&gt;enthusiasm:応募者の意気込み&lt;/li&gt; &lt;li&gt;opeComment:弊社担当からのコメント&lt;/li&gt; &lt;li&gt;selection:選定&lt;/li&gt; &lt;li&gt;isReserved:補欠採用&lt;/li&gt; &lt;li&gt;finalConfirm:最終可否&lt;/li&gt; &lt;li&gt;followers:フォロワー数/チャンネル登録者数&lt;/li&gt; &lt;li&gt;following:フォロー数&lt;/li&gt; &lt;li&gt;impressions:インプレッション数&lt;/li&gt; &lt;li&gt;egRate:エンゲージメント率&lt;/li&gt; &lt;li&gt;engagements:エンゲージメント数&lt;/li&gt; &lt;li&gt;good:いいね数&lt;/li&gt; &lt;li&gt;comments:コメント数&lt;/li&gt; &lt;li&gt;share:共有数&lt;/li&gt; &lt;li&gt;preserves:保存数&lt;/li&gt; &lt;li&gt;reach:ユニークアカウント数&lt;/li&gt; &lt;li&gt;reachRate:ユニークアカウント率&lt;/li&gt; &lt;li&gt;frequency:フリークエンシー&lt;/li&gt; &lt;li&gt;mediaCount:投稿数/ポスト数/動画数&lt;/li&gt; &lt;li&gt;reply:返信数&lt;/li&gt; &lt;li&gt;repost:リポスト数&lt;/li&gt; &lt;li&gt;views:再生数/視聴数&lt;/li&gt; &lt;li&gt;viewRate:再生回数率/視聴回数率&lt;/li&gt; &lt;li&gt;like:高評価数&lt;/li&gt; &lt;/ul&gt;
         * @param {GetSpiritApplicantsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpiritApplicants(projectId: string, rows?: GetSpiritApplicantsRowsEnum, page?: number, order?: GetSpiritApplicantsOrderEnum, orderBy?: GetSpiritApplicantsOrderByEnum, status?: GetSpiritApplicantsStatusEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritApplicantsOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpiritApplicants(projectId, rows, page, order, orderBy, status, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.getSpiritApplicants']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件詳細情報を返却する
         * @summary SPIRIT案件詳細情報取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpiritDetail(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpiritDetail(projectId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.getSpiritDetail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件種別の一覧を返却する
         * @summary SPIRIT案件一覧取得API
         * @param {GetSpiritListStatusEnum} [status] &lt;table&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;下書き&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件新規作成フローを経て案件内容が簡易提案された状態で保存した状態のこと（LIDDELL側に案件を依頼していない状態）&lt;/font&gt;&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;ここから「案件を開始」を選択すると、ステータスが「募集内容作成」に変更される&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;募集内容作成&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサー側に提示する募集内容の詳細を作成するフェーズ&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面、LDL管理画面から、募集内容の編集ができる&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にはLIDDELL側が作成する想定。（自力で募集内容の詳細を作成できるクライアントは少ないため）&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集内容の必須入力項目が全て記載されると、クライアントが確認→申請をする。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;その申請をLIDDELL側が管理画面で受け取り、スケジュールの日付設定をして承認することで「募集〜選定」フェーズへと移行する&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;無理のない案件スケジューリングを推奨するため、スケジュール設定権はLIDDELL側で持つ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt; &lt;font size&#x3D;\&quot;2\&quot;&gt;募集〜選定&lt;/font&gt; &lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集前の期間+募集期間+選定期間&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集が公開され、応募を受け付ける&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;応募者が応募者タブ内に表示されて、クライアント側で選定できるように&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサーを選定して、「採用者を確定する」ボタンを押すことで「最終確認」ステータスへ移行するイメージ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;最終確認&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LIDDELL側でインフルエンサーとやりとりをして、採用・補欠インフルエンサーに対し案件の遂行が可能かを最終確認する期間のこと&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LDL管理画面側で、最終確認完了のトリガーを設置する必要がある&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にこのフェーズ以降、クライアント側のタスクは発生しない&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;実施&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件を実施する期間。主にLIDDELL側とインフルエンサー側でやりとりをしながら、案件を遂行していく。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面側では、その進捗が反映される。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;スケジュールタブで、フェーズごとの実施ステータスが見れる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;完了&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;全ての稼働が完了（全てのインフルエンサーが案件へのフィードバックが完了）したら、案件完了ステータスとなる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;/table&gt;
         * @param {GetSpiritListListTypeEnum} [listType] 一覧種別
         * @param {GetSpiritListRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritListOrderEnum} [order] 
         * @param {string} [orderBy] ソート項目を指定しない場合、API仕様に応じてデフォルトのソート項目でソートされます。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpiritList(status?: GetSpiritListStatusEnum, listType?: GetSpiritListListTypeEnum, rows?: GetSpiritListRowsEnum, page?: number, order?: GetSpiritListOrderEnum, orderBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritListOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpiritList(status, listType, rows, page, order, orderBy, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.getSpiritList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件のスケジュールタブで表示するスケジュール情報を取得し返却する
         * @summary SPIRIT案件スケジュール取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSpiritSchedule(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpiritSchedule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSpiritSchedule(projectId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.getSpiritSchedule']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 詳細画像の設定を行うAPI<br> アップロード自体はamplifyで実装し、バックエンドにはS3オブジェクトのキー名のみ伝えます。<br> APIでDBに保存されているキー名にマッチしないキー名がリクエストされた場合、DBに登録されていたオブジェクトは削除し、<br> 新しいキー名を案件画像として登録します。<br> リクエストボディに含まれているキー名のみDBに登録されるため、配列から除外したキー名についてはDB、S3からも削除されます。
         * @summary 詳細画像設定API
         * @param {string} projectId 案件ID
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [deleteIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritMedia(projectId: string, uploads?: Array<File>, deleteIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritMedia(projectId, uploads, deleteIds, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritMedia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件の注意事項/公開設定を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件注意事項/公開設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritNoticeInput} [putSpiritNoticeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritNotice(projectId: string, putSpiritNoticeInput?: PutSpiritNoticeInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritNotice(projectId, putSpiritNoticeInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritNotice']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件のオプションを設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件オプション設定API
         * @param {string} projectId 案件ID
         * @param {SpiritSummaryOption} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritOptions(projectId: string, body?: SpiritSummaryOption, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritOptions(projectId, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritOptions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件の案件概要を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件概要設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritSummaryInput} [putSpiritSummaryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritSummary(projectId: string, putSpiritSummaryInput?: PutSpiritSummaryInput, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritSummary(projectId, putSpiritSummaryInput, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritSummary']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * SPIRIT案件の稼働設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件稼働設定API
         * @param {string} projectId 案件ID
         * @param {Array<SpiritTaskItem>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritTasks(projectId: string, body?: Array<SpiritTaskItem>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritTasks(projectId, body, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritTasks']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 案件タイトルやアイキャッチ画像などタイトル部分で表示する項目設定を行うAPI<br>保存された内容をレスポンスします。
         * @summary 案件募集タイトル作成/編集API
         * @param {string} projectId 案件ID
         * @param {string} title 
         * @param {Array<string>} tags 
         * @param {File} [featuredImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putSpiritTitle(projectId: string, title: string, tags: Array<string>, featuredImage?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSpiritDetailOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putSpiritTitle(projectId, title, tags, featuredImage, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['SPIRITApi.putSpiritTitle']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * SPIRITApi - factory interface
 * @export
 */
export const SPIRITApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SPIRITApiFp(configuration)
    return {
        /**
         * SPIRIT案件応募者のヒアリング情報を取得する
         * @summary SPIRIT案件応募者ヒアリング取得API
         * @param {string} projectId 案件ID
         * @param {string} snsAccountId インフルエンサーSNSアカウントID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritApplicantHearing(projectId: string, snsAccountId: string, options?: any): AxiosPromise<Array<SpiritHearingOption>> {
            return localVarFp.getSpiritApplicantHearing(projectId, snsAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件 応募者/採用者一覧を返却します。 <br> 案件のステータス状況に応じて応募者and採用者か、採用者のみ返却するかが変わります。
         * @summary SPIRIT案件 応募者/採用者一覧取得API
         * @param {string} projectId 案件ID
         * @param {GetSpiritApplicantsRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritApplicantsOrderEnum} [order] 
         * @param {GetSpiritApplicantsOrderByEnum} [orderBy] デフォルトは応募順 &lt;ul&gt; &lt;li&gt;follow:気になる&lt;/li&gt; &lt;li&gt;idx:応募順&lt;/li&gt; &lt;li&gt;id:SNS ID&lt;/li&gt; &lt;li&gt;eval:評価&lt;/li&gt; &lt;li&gt;enthusiasm:応募者の意気込み&lt;/li&gt; &lt;li&gt;opeComment:弊社担当からのコメント&lt;/li&gt; &lt;li&gt;selection:選定&lt;/li&gt; &lt;li&gt;isReserved:補欠採用&lt;/li&gt; &lt;li&gt;finalConfirm:最終可否&lt;/li&gt; &lt;li&gt;followers:フォロワー数/チャンネル登録者数&lt;/li&gt; &lt;li&gt;following:フォロー数&lt;/li&gt; &lt;li&gt;impressions:インプレッション数&lt;/li&gt; &lt;li&gt;egRate:エンゲージメント率&lt;/li&gt; &lt;li&gt;engagements:エンゲージメント数&lt;/li&gt; &lt;li&gt;good:いいね数&lt;/li&gt; &lt;li&gt;comments:コメント数&lt;/li&gt; &lt;li&gt;share:共有数&lt;/li&gt; &lt;li&gt;preserves:保存数&lt;/li&gt; &lt;li&gt;reach:ユニークアカウント数&lt;/li&gt; &lt;li&gt;reachRate:ユニークアカウント率&lt;/li&gt; &lt;li&gt;frequency:フリークエンシー&lt;/li&gt; &lt;li&gt;mediaCount:投稿数/ポスト数/動画数&lt;/li&gt; &lt;li&gt;reply:返信数&lt;/li&gt; &lt;li&gt;repost:リポスト数&lt;/li&gt; &lt;li&gt;views:再生数/視聴数&lt;/li&gt; &lt;li&gt;viewRate:再生回数率/視聴回数率&lt;/li&gt; &lt;li&gt;like:高評価数&lt;/li&gt; &lt;/ul&gt;
         * @param {GetSpiritApplicantsStatusEnum} [status] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritApplicants(projectId: string, rows?: GetSpiritApplicantsRowsEnum, page?: number, order?: GetSpiritApplicantsOrderEnum, orderBy?: GetSpiritApplicantsOrderByEnum, status?: GetSpiritApplicantsStatusEnum, options?: any): AxiosPromise<GetSpiritApplicantsOutput> {
            return localVarFp.getSpiritApplicants(projectId, rows, page, order, orderBy, status, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件詳細情報を返却する
         * @summary SPIRIT案件詳細情報取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritDetail(projectId: string, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.getSpiritDetail(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件種別の一覧を返却する
         * @summary SPIRIT案件一覧取得API
         * @param {GetSpiritListStatusEnum} [status] &lt;table&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;下書き&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件新規作成フローを経て案件内容が簡易提案された状態で保存した状態のこと（LIDDELL側に案件を依頼していない状態）&lt;/font&gt;&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;ここから「案件を開始」を選択すると、ステータスが「募集内容作成」に変更される&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;募集内容作成&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサー側に提示する募集内容の詳細を作成するフェーズ&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面、LDL管理画面から、募集内容の編集ができる&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にはLIDDELL側が作成する想定。（自力で募集内容の詳細を作成できるクライアントは少ないため）&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集内容の必須入力項目が全て記載されると、クライアントが確認→申請をする。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;その申請をLIDDELL側が管理画面で受け取り、スケジュールの日付設定をして承認することで「募集〜選定」フェーズへと移行する&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;無理のない案件スケジューリングを推奨するため、スケジュール設定権はLIDDELL側で持つ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt; &lt;font size&#x3D;\&quot;2\&quot;&gt;募集〜選定&lt;/font&gt; &lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集前の期間+募集期間+選定期間&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集が公開され、応募を受け付ける&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;応募者が応募者タブ内に表示されて、クライアント側で選定できるように&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサーを選定して、「採用者を確定する」ボタンを押すことで「最終確認」ステータスへ移行するイメージ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;最終確認&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LIDDELL側でインフルエンサーとやりとりをして、採用・補欠インフルエンサーに対し案件の遂行が可能かを最終確認する期間のこと&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LDL管理画面側で、最終確認完了のトリガーを設置する必要がある&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にこのフェーズ以降、クライアント側のタスクは発生しない&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;実施&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件を実施する期間。主にLIDDELL側とインフルエンサー側でやりとりをしながら、案件を遂行していく。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面側では、その進捗が反映される。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;スケジュールタブで、フェーズごとの実施ステータスが見れる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;完了&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;全ての稼働が完了（全てのインフルエンサーが案件へのフィードバックが完了）したら、案件完了ステータスとなる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;/table&gt;
         * @param {GetSpiritListListTypeEnum} [listType] 一覧種別
         * @param {GetSpiritListRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
         * @param {number} [page] 
         * @param {GetSpiritListOrderEnum} [order] 
         * @param {string} [orderBy] ソート項目を指定しない場合、API仕様に応じてデフォルトのソート項目でソートされます。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritList(status?: GetSpiritListStatusEnum, listType?: GetSpiritListListTypeEnum, rows?: GetSpiritListRowsEnum, page?: number, order?: GetSpiritListOrderEnum, orderBy?: string, options?: any): AxiosPromise<GetSpiritListOutput> {
            return localVarFp.getSpiritList(status, listType, rows, page, order, orderBy, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件のスケジュールタブで表示するスケジュール情報を取得し返却する
         * @summary SPIRIT案件スケジュール取得API
         * @param {string} projectId 案件ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSpiritSchedule(projectId: string, options?: any): AxiosPromise<Array<SpiritSchedule>> {
            return localVarFp.getSpiritSchedule(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 詳細画像の設定を行うAPI<br> アップロード自体はamplifyで実装し、バックエンドにはS3オブジェクトのキー名のみ伝えます。<br> APIでDBに保存されているキー名にマッチしないキー名がリクエストされた場合、DBに登録されていたオブジェクトは削除し、<br> 新しいキー名を案件画像として登録します。<br> リクエストボディに含まれているキー名のみDBに登録されるため、配列から除外したキー名についてはDB、S3からも削除されます。
         * @summary 詳細画像設定API
         * @param {string} projectId 案件ID
         * @param {Array<File>} [uploads] 
         * @param {Array<string>} [deleteIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritMedia(projectId: string, uploads?: Array<File>, deleteIds?: Array<string>, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritMedia(projectId, uploads, deleteIds, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件の注意事項/公開設定を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件注意事項/公開設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritNoticeInput} [putSpiritNoticeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritNotice(projectId: string, putSpiritNoticeInput?: PutSpiritNoticeInput, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritNotice(projectId, putSpiritNoticeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件のオプションを設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件オプション設定API
         * @param {string} projectId 案件ID
         * @param {SpiritSummaryOption} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritOptions(projectId: string, body?: SpiritSummaryOption, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritOptions(projectId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件の案件概要を設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件概要設定API
         * @param {string} projectId 案件ID
         * @param {PutSpiritSummaryInput} [putSpiritSummaryInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritSummary(projectId: string, putSpiritSummaryInput?: PutSpiritSummaryInput, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritSummary(projectId, putSpiritSummaryInput, options).then((request) => request(axios, basePath));
        },
        /**
         * SPIRIT案件の稼働設定するAPIです。<br>保存された内容をレスポンスします。
         * @summary 案件稼働設定API
         * @param {string} projectId 案件ID
         * @param {Array<SpiritTaskItem>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritTasks(projectId: string, body?: Array<SpiritTaskItem>, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritTasks(projectId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 案件タイトルやアイキャッチ画像などタイトル部分で表示する項目設定を行うAPI<br>保存された内容をレスポンスします。
         * @summary 案件募集タイトル作成/編集API
         * @param {string} projectId 案件ID
         * @param {string} title 
         * @param {Array<string>} tags 
         * @param {File} [featuredImage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putSpiritTitle(projectId: string, title: string, tags: Array<string>, featuredImage?: File, options?: any): AxiosPromise<GetSpiritDetailOutput> {
            return localVarFp.putSpiritTitle(projectId, title, tags, featuredImage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SPIRITApi - object-oriented interface
 * @export
 * @class SPIRITApi
 * @extends {BaseAPI}
 */
export class SPIRITApi extends BaseAPI {
    /**
     * SPIRIT案件応募者のヒアリング情報を取得する
     * @summary SPIRIT案件応募者ヒアリング取得API
     * @param {string} projectId 案件ID
     * @param {string} snsAccountId インフルエンサーSNSアカウントID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public getSpiritApplicantHearing(projectId: string, snsAccountId: string, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).getSpiritApplicantHearing(projectId, snsAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件 応募者/採用者一覧を返却します。 <br> 案件のステータス状況に応じて応募者and採用者か、採用者のみ返却するかが変わります。
     * @summary SPIRIT案件 応募者/採用者一覧取得API
     * @param {string} projectId 案件ID
     * @param {GetSpiritApplicantsRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
     * @param {number} [page] 
     * @param {GetSpiritApplicantsOrderEnum} [order] 
     * @param {GetSpiritApplicantsOrderByEnum} [orderBy] デフォルトは応募順 &lt;ul&gt; &lt;li&gt;follow:気になる&lt;/li&gt; &lt;li&gt;idx:応募順&lt;/li&gt; &lt;li&gt;id:SNS ID&lt;/li&gt; &lt;li&gt;eval:評価&lt;/li&gt; &lt;li&gt;enthusiasm:応募者の意気込み&lt;/li&gt; &lt;li&gt;opeComment:弊社担当からのコメント&lt;/li&gt; &lt;li&gt;selection:選定&lt;/li&gt; &lt;li&gt;isReserved:補欠採用&lt;/li&gt; &lt;li&gt;finalConfirm:最終可否&lt;/li&gt; &lt;li&gt;followers:フォロワー数/チャンネル登録者数&lt;/li&gt; &lt;li&gt;following:フォロー数&lt;/li&gt; &lt;li&gt;impressions:インプレッション数&lt;/li&gt; &lt;li&gt;egRate:エンゲージメント率&lt;/li&gt; &lt;li&gt;engagements:エンゲージメント数&lt;/li&gt; &lt;li&gt;good:いいね数&lt;/li&gt; &lt;li&gt;comments:コメント数&lt;/li&gt; &lt;li&gt;share:共有数&lt;/li&gt; &lt;li&gt;preserves:保存数&lt;/li&gt; &lt;li&gt;reach:ユニークアカウント数&lt;/li&gt; &lt;li&gt;reachRate:ユニークアカウント率&lt;/li&gt; &lt;li&gt;frequency:フリークエンシー&lt;/li&gt; &lt;li&gt;mediaCount:投稿数/ポスト数/動画数&lt;/li&gt; &lt;li&gt;reply:返信数&lt;/li&gt; &lt;li&gt;repost:リポスト数&lt;/li&gt; &lt;li&gt;views:再生数/視聴数&lt;/li&gt; &lt;li&gt;viewRate:再生回数率/視聴回数率&lt;/li&gt; &lt;li&gt;like:高評価数&lt;/li&gt; &lt;/ul&gt;
     * @param {GetSpiritApplicantsStatusEnum} [status] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public getSpiritApplicants(projectId: string, rows?: GetSpiritApplicantsRowsEnum, page?: number, order?: GetSpiritApplicantsOrderEnum, orderBy?: GetSpiritApplicantsOrderByEnum, status?: GetSpiritApplicantsStatusEnum, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).getSpiritApplicants(projectId, rows, page, order, orderBy, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件詳細情報を返却する
     * @summary SPIRIT案件詳細情報取得API
     * @param {string} projectId 案件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public getSpiritDetail(projectId: string, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).getSpiritDetail(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件種別の一覧を返却する
     * @summary SPIRIT案件一覧取得API
     * @param {GetSpiritListStatusEnum} [status] &lt;table&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;下書き&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件新規作成フローを経て案件内容が簡易提案された状態で保存した状態のこと（LIDDELL側に案件を依頼していない状態）&lt;/font&gt;&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;ここから「案件を開始」を選択すると、ステータスが「募集内容作成」に変更される&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;募集内容作成&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサー側に提示する募集内容の詳細を作成するフェーズ&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面、LDL管理画面から、募集内容の編集ができる&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にはLIDDELL側が作成する想定。（自力で募集内容の詳細を作成できるクライアントは少ないため）&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集内容の必須入力項目が全て記載されると、クライアントが確認→申請をする。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;その申請をLIDDELL側が管理画面で受け取り、スケジュールの日付設定をして承認することで「募集〜選定」フェーズへと移行する&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;無理のない案件スケジューリングを推奨するため、スケジュール設定権はLIDDELL側で持つ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt; &lt;font size&#x3D;\&quot;2\&quot;&gt;募集〜選定&lt;/font&gt; &lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集前の期間+募集期間+選定期間&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;募集が公開され、応募を受け付ける&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;応募者が応募者タブ内に表示されて、クライアント側で選定できるように&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;インフルエンサーを選定して、「採用者を確定する」ボタンを押すことで「最終確認」ステータスへ移行するイメージ&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;最終確認&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LIDDELL側でインフルエンサーとやりとりをして、採用・補欠インフルエンサーに対し案件の遂行が可能かを最終確認する期間のこと&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;LDL管理画面側で、最終確認完了のトリガーを設置する必要がある&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;基本的にこのフェーズ以降、クライアント側のタスクは発生しない&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;実施&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;案件を実施する期間。主にLIDDELL側とインフルエンサー側でやりとりをしながら、案件を遂行していく。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;クライアント画面側では、その進捗が反映される。&lt;/font&gt;&lt;/div&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;スケジュールタブで、フェーズごとの実施ステータスが見れる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;tr&gt; &lt;td&gt;&lt;font size&#x3D;\&quot;2\&quot;&gt;完了&lt;/font&gt;&lt;/td&gt; &lt;td&gt; &lt;div&gt;&lt;font size&#x3D;\&quot;1\&quot;&gt;全ての稼働が完了（全てのインフルエンサーが案件へのフィードバックが完了）したら、案件完了ステータスとなる&lt;/font&gt;&lt;/div&gt; &lt;/td&gt; &lt;/tr&gt; &lt;/table&gt;
     * @param {GetSpiritListListTypeEnum} [listType] 一覧種別
     * @param {GetSpiritListRowsEnum} [rows] ページ行数を指定しない場合、API仕様に応じてデフォルトのページ行数で返却されます。
     * @param {number} [page] 
     * @param {GetSpiritListOrderEnum} [order] 
     * @param {string} [orderBy] ソート項目を指定しない場合、API仕様に応じてデフォルトのソート項目でソートされます。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public getSpiritList(status?: GetSpiritListStatusEnum, listType?: GetSpiritListListTypeEnum, rows?: GetSpiritListRowsEnum, page?: number, order?: GetSpiritListOrderEnum, orderBy?: string, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).getSpiritList(status, listType, rows, page, order, orderBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件のスケジュールタブで表示するスケジュール情報を取得し返却する
     * @summary SPIRIT案件スケジュール取得API
     * @param {string} projectId 案件ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public getSpiritSchedule(projectId: string, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).getSpiritSchedule(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 詳細画像の設定を行うAPI<br> アップロード自体はamplifyで実装し、バックエンドにはS3オブジェクトのキー名のみ伝えます。<br> APIでDBに保存されているキー名にマッチしないキー名がリクエストされた場合、DBに登録されていたオブジェクトは削除し、<br> 新しいキー名を案件画像として登録します。<br> リクエストボディに含まれているキー名のみDBに登録されるため、配列から除外したキー名についてはDB、S3からも削除されます。
     * @summary 詳細画像設定API
     * @param {string} projectId 案件ID
     * @param {Array<File>} [uploads] 
     * @param {Array<string>} [deleteIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritMedia(projectId: string, uploads?: Array<File>, deleteIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritMedia(projectId, uploads, deleteIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件の注意事項/公開設定を設定するAPIです。<br>保存された内容をレスポンスします。
     * @summary 案件注意事項/公開設定API
     * @param {string} projectId 案件ID
     * @param {PutSpiritNoticeInput} [putSpiritNoticeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritNotice(projectId: string, putSpiritNoticeInput?: PutSpiritNoticeInput, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritNotice(projectId, putSpiritNoticeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件のオプションを設定するAPIです。<br>保存された内容をレスポンスします。
     * @summary 案件オプション設定API
     * @param {string} projectId 案件ID
     * @param {SpiritSummaryOption} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritOptions(projectId: string, body?: SpiritSummaryOption, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritOptions(projectId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件の案件概要を設定するAPIです。<br>保存された内容をレスポンスします。
     * @summary 案件概要設定API
     * @param {string} projectId 案件ID
     * @param {PutSpiritSummaryInput} [putSpiritSummaryInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritSummary(projectId: string, putSpiritSummaryInput?: PutSpiritSummaryInput, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritSummary(projectId, putSpiritSummaryInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * SPIRIT案件の稼働設定するAPIです。<br>保存された内容をレスポンスします。
     * @summary 案件稼働設定API
     * @param {string} projectId 案件ID
     * @param {Array<SpiritTaskItem>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritTasks(projectId: string, body?: Array<SpiritTaskItem>, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritTasks(projectId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 案件タイトルやアイキャッチ画像などタイトル部分で表示する項目設定を行うAPI<br>保存された内容をレスポンスします。
     * @summary 案件募集タイトル作成/編集API
     * @param {string} projectId 案件ID
     * @param {string} title 
     * @param {Array<string>} tags 
     * @param {File} [featuredImage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SPIRITApi
     */
    public putSpiritTitle(projectId: string, title: string, tags: Array<string>, featuredImage?: File, options?: RawAxiosRequestConfig) {
        return SPIRITApiFp(this.configuration).putSpiritTitle(projectId, title, tags, featuredImage, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetSpiritApplicantsRowsEnum = {
    NUMBER_10: 10,
    NUMBER_30: 30,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetSpiritApplicantsRowsEnum = typeof GetSpiritApplicantsRowsEnum[keyof typeof GetSpiritApplicantsRowsEnum];
/**
 * @export
 */
export const GetSpiritApplicantsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetSpiritApplicantsOrderEnum = typeof GetSpiritApplicantsOrderEnum[keyof typeof GetSpiritApplicantsOrderEnum];
/**
 * @export
 */
export const GetSpiritApplicantsOrderByEnum = {
    Follow: 'follow',
    Idx: 'idx',
    Id: 'id',
    Eval: 'eval',
    Enthusiasm: 'enthusiasm',
    OpeComment: 'opeComment',
    Selection: 'selection',
    IsReserved: 'isReserved',
    FinalConfirm: 'finalConfirm',
    Followers: 'followers',
    Following: 'following',
    Impressions: 'impressions',
    EgRate: 'egRate',
    Engagements: 'engagements',
    Good: 'good',
    Comments: 'comments',
    Share: 'share',
    Preserves: 'preserves',
    Reach: 'reach',
    ReachRate: 'reachRate',
    Frequency: 'frequency',
    MediaCount: 'mediaCount',
    Reply: 'reply',
    Repost: 'repost',
    Views: 'views',
    ViewRate: 'viewRate',
    Like: 'like'
} as const;
export type GetSpiritApplicantsOrderByEnum = typeof GetSpiritApplicantsOrderByEnum[keyof typeof GetSpiritApplicantsOrderByEnum];
/**
 * @export
 */
export const GetSpiritApplicantsStatusEnum = {
    Approved: 'approved',
    Reserved: 'reserved',
    Rejected: 'rejected'
} as const;
export type GetSpiritApplicantsStatusEnum = typeof GetSpiritApplicantsStatusEnum[keyof typeof GetSpiritApplicantsStatusEnum];
/**
 * @export
 */
export const GetSpiritListStatusEnum = {
    Draft: 'draft',
    Review: 'review',
    Approved: 'approved',
    FinalConfirmation: 'final_confirmation',
    Implementation: 'implementation',
    Completion: 'completion'
} as const;
export type GetSpiritListStatusEnum = typeof GetSpiritListStatusEnum[keyof typeof GetSpiritListStatusEnum];
/**
 * @export
 */
export const GetSpiritListListTypeEnum = {
    Analysis: 'analysis'
} as const;
export type GetSpiritListListTypeEnum = typeof GetSpiritListListTypeEnum[keyof typeof GetSpiritListListTypeEnum];
/**
 * @export
 */
export const GetSpiritListRowsEnum = {
    NUMBER_10: 10,
    NUMBER_30: 30,
    NUMBER_50: 50,
    NUMBER_100: 100
} as const;
export type GetSpiritListRowsEnum = typeof GetSpiritListRowsEnum[keyof typeof GetSpiritListRowsEnum];
/**
 * @export
 */
export const GetSpiritListOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetSpiritListOrderEnum = typeof GetSpiritListOrderEnum[keyof typeof GetSpiritListOrderEnum];


